import { render, staticRenderFns } from "./MsCombobox.vue?vue&type=template&id=353bbdbc&scoped=true"
import script from "./MsCombobox.vue?vue&type=script&lang=js"
export * from "./MsCombobox.vue?vue&type=script&lang=js"
import style0 from "./MsCombobox.vue?vue&type=style&index=0&id=353bbdbc&prod&lang=scss&scoped=true"
import style1 from "./MsCombobox.vue?vue&type=style&index=1&id=353bbdbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353bbdbc",
  null
  
)

export default component.exports